<div class="change-name-dialog">

  <!-- Close button -->
  <div class="dialog-title-row">
    <span></span>
    <button class="btn-close-dialog" mat-dialog-close><i class="fa-light fa-times"></i></button>
  </div>

  <!-- Header -->
  <div class="dialog-header">
    <div class="dialog-icon-wrap">
      <i class="fa-light fa-user-pen"></i>
    </div>
    <h2 class="dialog-title">Cambiar nombre</h2>
    <p class="dialog-subtitle">Introduce el nuevo nombre o razón social de tu cuenta.</p>
  </div>

  <form [formGroup]="changeForm" (ngSubmit)="changeName()">

    <div class="field-group">
      <label class="field-label">Nombre / Organización</label>
      <div class="input-wrap" [class.input-invalid]="name.invalid && (name.dirty || name.touched)">
        <i class="fa-light fa-user input-icon"></i>
        <input type="text" placeholder="Introduce el nuevo nombre" formControlName="name" required />
      </div>
      <p class="error-msg" *ngIf="name.invalid && (name.dirty || name.touched)">
        <i class="fa-light fa-triangle-exclamation"></i> Este campo es obligatorio.
      </p>
    </div>

    <button type="submit" class="submit-btn" [disabled]="changeForm.invalid">
      Guardar cambios
    </button>

  </form>
</div>
